import { NameValueObject } from "../models/globals";

export class EnumHelper {

  /** Returns array of objects based on enum values.
   *  Every object has text and value. 
   * Formats enum names if they are in pascal case.*/
  public static getTextAndValue(type: any, pascalCase: boolean = false): NameValueObject[] {
    const result: Array<NameValueObject> = [];
    let typeNames = Object.keys(type).filter((x) => !Number(x) && x != "0");
    for (var value in typeNames) {
      result.push({ name: type[value], value: value })
    }
    return result;
  }

  public static getValueOfEntry(type: any, nameOfEntry): number {
    const result: number = 0;
    let typeNames = Object.keys(type).filter((x) => !Number(x) && x != "0");
    return typeNames.findIndex(x => x == nameOfEntry);
  }
}